import React from 'react';
import './pricing.css';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../ThemeContext';
import { useAuthContext } from '../../hooks/useAuthContext';
import PricingCards from './pricingCards';
import { FiArrowLeft } from 'react-icons/fi';

function Pricing() {
  const navigate = useNavigate();
  const { darkMode } = useTheme();
  const { user } = useAuthContext();

  return (
    <div className={`pricingPage ${darkMode ? 'dark-mode' : 'light-mode'}`}>
      <div className="pricingPageInner">
        <button className="pricingBack" onClick={() => navigate(user ? '/app/resume' : '/')}>
          <FiArrowLeft size={15} /> Back
        </button>
        <h1 className="pricingPageTitle">Simple, honest pricing</h1>
        <p className="pricingPageSubtitle">
          Start free. Upgrade when you need more tailored resumes and a place to keep them.
        </p>
        <PricingCards />
      </div>
    </div>
  );
}

export default Pricing;
